<script setup lang="ts">
import { useId, watch } from 'vue'
import mdiClose from '~icons/mdi/close'
import BTooltipBtn from '@/components/base/BTooltipBtn/BTooltipBtn.vue'

const props = withDefaults(
  defineProps<{
    title?: string
    location?: 'left' | 'right'
  }>(),
  {
    title: undefined,
    location: 'right',
  }
)

const emit = defineEmits<{
  close: []
}>()

const model = defineModel<boolean>()
const titleId = useId()

watch(model, (newVal, oldVal) => {
  if (oldVal && !newVal) emit('close')
})

function close() {
  model.value = false
}
</script>

<template>
  <v-navigation-drawer
    v-model="model"
    :location="props.location"
    :aria-labelledby="titleId"
    width="550"
    class="side-drawer"
    temporary
  >
    <section class="d-flex flex-column fill-height">
      <header class="d-flex align-center pa-4 border-b">
        <h1
          :id="titleId"
          class="text-headline-medium"
        >
          <slot name="title">{{ props.title }}</slot>
        </h1>
        <v-spacer />
        <b-tooltip-btn
          :icon="mdiClose"
          variant="text"
          tooltip="close"
          @click="close"
        />
      </header>

      <div class="flex-grow-1 overflow-y-auto">
        <slot />
      </div>

      <footer
        v-if="$slots.footer"
        class="pa-4 border-t"
      >
        <slot name="footer" />
      </footer>
    </section>
  </v-navigation-drawer>
</template>
